import { IWordingsContext } from './wordingsContext';

export enum WordingsActionsTypes {
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_GROUP = 'SET_GROUP',
	SET_LANGUAGE = 'SET_LANGUAGE',
	SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES',
	ADD_INVALID_FIELD = 'ADD_INVALID_FIELD',
	CLEAR_INVALID_FIELDS = 'CLEAR_INVALID_FIELDS',
	REMOVE_WORDING = 'REMOVE_WORDING',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	SET_DELETE_WORDING_DATA = 'SET_DELETE_WORDING_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetAllData {
	type: WordingsActionsTypes.SET_ALL_DATA;
	payload: {
		groups: IWordingsContext['groups'];
	};
}

interface ISetGroup {
	type: WordingsActionsTypes.SET_GROUP;
	payload: {
		selectedGroup: IWordingsContext['selectedGroup'];
	};
}

interface ISetLanguage {
	type: WordingsActionsTypes.SET_LANGUAGE;
	payload: {
		selectedLanguage: IWordingsContext['selectedLanguage'];
	};
}

interface ISetAvailableLanguages {
	type: WordingsActionsTypes.SET_AVAILABLE_LANGUAGES;
	payload: {
		availableLanguages: IWordingsContext['availableLanguages'];
	};
}

interface IAddInvalidField {
	type: WordingsActionsTypes.ADD_INVALID_FIELD;
	payload: {
		invalidField: IWordingsContext['invalidFields'][0];
	};
}

interface IClearInvalidFields {
	type: WordingsActionsTypes.CLEAR_INVALID_FIELDS;
}

interface IRemoveWording {
	type: WordingsActionsTypes.REMOVE_WORDING;
	payload: {
		groups: IWordingsContext['groups'];
	};
}

interface ISetDataForSubmit {
	type: WordingsActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IWordingsContext['dataForSubmit'];
	};
}

interface ISetDeleteWordingData {
	type: WordingsActionsTypes.SET_DELETE_WORDING_DATA;
	payload: {
		deleteWordingData: IWordingsContext['deleteWordingData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: WordingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IWordingsContext['typeOfModalWindow'];
	};
}

export type TWordingsAction =
	| ISetAllData
	| ISetGroup
	| ISetLanguage
	| ISetAvailableLanguages
	| IAddInvalidField
	| IClearInvalidFields
	| IRemoveWording
	| ISetDataForSubmit
	| ISetDeleteWordingData
	| IChangeTypeOfModalWindow;
